import { useCallback, useEffect, useState } from 'react';
import useAxios from '../hooks/useAxios';

let isRunning = false;

export const AncillaryIconMappings = {
    'give now': {
        name: 'sprout',
        type: 'material-community'
    },
    visit: {
        name: 'cross',
        type: 'material-community'
    },
    watch: {
        name: 'youtube',
        type: 'material-community'
    }
};

export const collectAncillaryOptions = siteWrapper => {
    const ancillary = siteWrapper?.contentItems?.['Ancillary Navigation'];
    const options = {
        logo: undefined,
        links: [],
        menus: []
    };

    if (ancillary) {
        const icon = ancillary?.logo?.cdnImagePath;

        if (icon) {
            options.logo = `https:${icon}`;
        }

        const links = ancillary.contentItems?.Links;

        if (links) {
            Object.values(links.contentItems ?? {}).forEach(link => {
                const isExternal = link.link.startsWith('http');

                options.links.push({
                    text: link.linkText,
                    url: link.link,
                    isExternal
                });
            });
        }

        const menus = ancillary.contentItems?.Menus;

        if (menus) {
            Object.values(menus.contentItems ?? {}).forEach(menu => {
                const name = menu.linkText;
                const entries = [];

                Object.values(menu.contentItems ?? {}).forEach(menuEntry => {
                    const isExternal = menuEntry.link.startsWith('http');

                    entries.push({
                        name,
                        text: menuEntry.linkText,
                        url: menuEntry.link,
                        isExternal
                    });
                });

                options.menus.push({
                    entries,
                    name
                });
            });
        }
    }

    return options;
};

export const findActive = (path, depth) => {
    if (path?.equals('/')) {
        return '/';
    } else {
        let activePath;

        if (path?.lastIndexOf('/') === path?.length - 1) {
            activePath = path?.slice(1, -1);
        } else {
            activePath = path?.replace('/', '');
        }

        if (activePath) {
            const parts = activePath.split('/');

            if (Array.isArray(parts)) {
                if (depth && depth <= parts.length) {
                    return parts[depth];
                } else {
                    return parts[0];
                }
            }
        }
    }

    return undefined;
};

const parseNavigation = data => {
    if (!data || Object.keys(data).length === 0) {
        return null;
    }

    const primary = [];
    const secondary = {};
    const tertiary = {};
    let autoPopulateTertiary = false;

    Object.keys(data).forEach(key => {
        const entry = data[key];

        if (entry.rootPath?.equals('/') || entry.navigationOnly) {
            primary.push(entry);
        } else if (entry.rootPath?.substring(1, entry.rootPath.length).split('/').length === 1) {
            primary.push(entry);
        } else if (!entry.navigationOnly) {
            if (entry.rootPath?.charCount('/') > 1) {
                const path = entry.rootPath?.slice(1).split('/');
                const parent = path[0];

                if (!secondary.hasOwnProperty(parent)) {
                    secondary[parent] = [entry];
                } else {
                    secondary[path[0]].push(entry);
                }

                secondary[path[0]].sort((a, b) => a.sortOrder - b.sortOrder);
            }
        }
    });

    // if (settings.websiteSettings?.environment?.equals('Staging') || settings.websiteSettings?.environment?.equals('Development')) {
    //     primary.push({
    //         id: '999999',
    //         title: 'Test',
    //         menuItemText: 'Test',
    //         openInNewPage: false,
    //         hasAncillaryNavigation: true,
    //         doNotIncludeInNavigation: false,
    //         navigationOnly: false,
    //         rootPath: '/test',
    //         sortOrder: 15
    //     });
    // }

    primary.sort((a, b) => a.sortOrder - b.sortOrder);

    return {
        autoPopulateTertiary,
        primary,
        secondary,
        tertiary
    };
};

const useNavigation = () => {
    const { get: _Get } = useAxios();
    const [navigation, setNavigation] = useState();

    const fetchNavigation = useCallback(async () => {
        if (navigation || isRunning) {
            return navigation;
        }

        isRunning = true;
        const response = await _Get('/api/cms/GetNavigation');

        if (response) {
            setNavigation(parseNavigation(response));
        }
        isRunning = false;
    }, [_Get, navigation]);

    useEffect(() => {
        (async () => await fetchNavigation())();
    }, [fetchNavigation, navigation]);

    return navigation;
};

export default useNavigation;
